<template>
	<div class="mynews">
      <div class="new">
        <v-header :goBackac='true' :mine='true' :isminenews="true" @editmsg='editmsg' v-show="isable"></v-header>
        <v-header :isback='true' :mine='true' @backmsg='backmsg' v-show="!isable"></v-header>
        <span class="title" v-show="false">{{$t('mynews.masternews')}}</span>
		<div class="pro_pic" v-show="isable">
			<img :src="picimg?picimg:defaultimg" alt=" "/>
		</div>
      	<div class="pro_pic" v-show="!isable">
	      	<img :src="imgflag?avatar:avatar1" @click.stop="uploadHeadImg"  v-show="isshow"/>
        	<canvas ref="can" v-show="showflag" style="width: 5.2rem;height: 5.2rem;overflow: hidden;margin: auto;display: block;border-radius: 50%;" @click.stop="uploadHeadImg"></canvas>
	      	<input type="file" accept="image/*" @change="handleFile" class="hiddenInput" />
	    </div>
			<div class="news">
				<div class="pos"><span><img src="../../../static/img/account2/nick.png" alt="">{{$t('mynews.mastername')}}</span><input :disabled="isable" v-model="nc" maxlength="12" ref='name'></div>
				<div class="pos"><span><img src="../../../static/img/account2/sex.png" alt="">{{$t('mynews.mastersex')}}</span><input :disabled="true" v-model="sex" v-show="isable">
        <el-select class="sel" v-model="value" :placeholder="$t('mynewsedit.ChoiceSex')" v-show="!isable">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
        </el-select>
        </div>
				<div class="pos"><span><img src="../../../static/img/account2/email.png" alt="">{{$t('mynews.masteremail')}}</span><input :disabled="isable" v-model="em"></div>
        		<p class="denger" v-show="flag3">{{$t('forgetpassword.NotEmail')}}</p>
				<p class="denger" v-show="flag4">{{$t('forgetpassword.FalseEmail')}}</p>
				<div class="pos"><span><img src="../../../static/img/account2/phone.png" alt="">{{$t('mynews.masterphone')}}</span><input :disabled="isable" v-model="phone"></div>
        <p class="denger" v-show="flag5">{{$t('forgetpassword.FalsePhone')}}</P>
        <p class="denger" v-show="flag6">{{$t('forgetpassword.NotPhone')}}</P>
				<div class="pos"><span><img src="../../../static/img/account2/addr.png" alt="">{{$t('mynews.masteradr')}}</span><input :disabled="isable" v-model="adr"></div>
        <el-button @click="finish" v-show="!isable">{{$t('mynewsedit.finish')}}</el-button>
			</div>
        <el-button type="primary" style='margin:10px auto;display: block;width: 80%;' v-show='flag1' @click='next'>{{$t('forgetpassword.next')}}</el-button>
      </div>
	</div>
</template>

<script>
import { getLoginUser } from "../../api/index.js";
import { updateUserInfo, updateBasicInfo } from "../../api/index.js";
import Axios from "axios";
import EXIF from 'exif-js/exif.js'
import Qs from "qs";
import header from "../../components/header";
export default {
  name: "mynews",
  inject: ["reload"],
  data() {
    return {
      nc: "",
      sex: "",
      em: "",
      phone: "",
      adr: "",
      defaultimg:require("../../image/account.png"),
      picimg: '',
      flag: true,
      flag1: false,
      imgflag: true,
      isable:true,
      avatar: require("../../image/addmypet.png"),
      avatar1: "",
      options: [
        {
          value: true,
          label: this.$t('mynewsedit.boy')
        },
        {
          value: false,
          label: this.$t('mynewsedit.girl')
        }
      ],
      value: "",
      isshow:true,
      showflag:false,
      id:"",
      flag2: false,
      flag3: false,
      flag4: false,
      flag5: false,
      flag6:false,
      picImg: "",
      upload:this.$t('mynewsedit.failure')
    };
  },
  components:{
    "v-header":header
  },
  created(){
       if(sessionStorage.third){
        this.flag = false
        this.flag1 = true
      }
      //检验是否登录超时
      if (sessionStorage.getItem("login") == 1) {
        getLoginUser()
          .then(res => {
            if (res.data.header.status == 3019) {
              sessionStorage.setItem("login", "1");
              this.$message({
                type: "success",
                message: this.$t("prompt.header")
              });
              this.$router.push("/login");
            }
          })
          .catch(err => {});
      }
  },
  mounted() {
    getLoginUser()
      .then(res => {
        
        this.nc = res.data.data.nickname;
        if (res.data.data.sex == true) {
          this.sex = this.$t('mynewsedit.boy');
        } else if (res.data.data.sex == false) {
          this.sex = this.$t('mynewsedit.girl');
        }

        this.em = res.data.data.email;
        this.phone = res.data.data.mobile;
        this.adr = res.data.data.address;
        this.value = res.data.data.sex;
        this.picimg = res.data.data.photoUrl;

        if (res.data.data.photoUrl) {
          this.avatar = res.data.data.photoUrl;
        }
      })
      .catch(error => {
        console.log(error);
      });
  },
  methods: {
    backmsg(){
      this.isable = true
      this.reload()
    },
    editmsg(){
      this.isable = false
      setTimeout(()=>{
        this.$refs.name.focus()
      },300)
      this.$refs.name.focus()
    },
    next(){
      sessionStorage.removeItem("third");
      this.$router.push('/myAccount')
    },
     // 打开图片上传
    uploadHeadImg: function() {
      this.$el.querySelector(".hiddenInput").click();
    },
    // 将头像显示
    handleFile: function(e) {
      var th = this;
      th.imgflag = true;
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      let maxSize = 400 * 1024;
      var reader = new FileReader();
      let Orientation;
       EXIF.getData(file, function() {
		    Orientation = EXIF.getTag(this, 'Orientation');
        });
      if(file){
      reader.readAsDataURL(file);
      }
      reader.onload = data => {
        console.log("data", data);
        let res = data.target || data.srcElement;
        if(data.total < maxSize){
          th.showflag = false
          th.isshow = true
            th.avatar = res.result;
            th.picImg = data.target.result.split(",")[1]
        }else{
          th.compress(res.result,Orientation)
        }
      };
    },
    compress(result,Orientation){
     var img = new Image();
     var th = this
     img.src = result;
     th.showflag = true
     th.isshow = false
    img.onload = function() {
    var width =  img.width;
    var height =  img.height;
    var canvas = th.$refs.can;
    var ratio = 400;
    if (width > ratio) {
          var scaling = 1-(width-ratio)/width;
            width = width * scaling;
            height = height * scaling;
        }
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext('2d');
          if(Orientation != "" && Orientation != 1&& Orientation != undefined){
        switch(Orientation){
          case 6://需要顺时针（向左）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(90 * Math.PI / 180);
              ctx.drawImage(img, 0, 0,width, -height);
              break;
          case 8://需要逆时针（向右）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(-90 * Math.PI / 180);
              ctx.drawImage(img,0, 0, -width, 0);
              break;
          case 3://需要180度旋转
             ctx.rotate(180 * Math.PI / 180);
             ctx.drawImage(img,0, 0, -width, -height);
             break;
        }
      }else{
         canvas.getContext("2d").drawImage(img, 0, 0, width, height);  
      }    
    var base64 =canvas.toDataURL("image/jpeg", 0.15);                      
    th.picImg = base64.split(",")[1]      
    th.avatar = base64.result;             

  };
    },
    finish() {
      if (this.picImg == "") {
        var params = Qs.stringify({
            nickname: this.nc,
            sex: this.value,
            mobile: this.phone,
            email: this.em,
            address: this.adr
        });
      } else {
        var params = Qs.stringify({
            nickname: this.nc,
            sex: this.value,
            mobile: this.phone,
            email: this.em,
            photoUrl: this.picImg,
            address: this.adr
        });
      }
      updateBasicInfo(params)//修改用户基本信息
        .then(res => {
          console.log('提交返回：',res);
          if (res.data.header.status == "1000") {
              this.ifedit=false
              this.reload()
          } else {
            this.$message({
              message: this.upload,
              type: "warning"
            });
          }
        })
        .catch(error => {
          console.log(error);
        })
      // let reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
      // let reg1 = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/;
      // if(this.phone.length>0){
      //       if(reg1.test(this.phone)){
      //         this.flag5=false;
      //         if(reg.test(this.em)){
      //           this.flag3=false;
      //           this.flag4=false;
      //           this.flag5=false;
      //           if (this.picImg == "") {
      //             var params = Qs.stringify({
      //               nickname: this.nc,
      //               sex: this.value,
      //               mobile: this.phone,
      //               email: this.em,
      //               address: this.adr
      //             });
      //           }else {
      //           var params = Qs.stringify({
      //               nickname: this.nc,
      //               sex: this.value,
      //               mobile: this.phone,
      //               email: this.em,
      //               photoUrl: this.picImg,
      //               address: this.adr
      //             });
      //           }
      //           updateBasicInfo(params)//修改用户基本信息
      //             .then(res => {
      //               console.log('提交返回：',res);
      //               if (res.data.header.status == "1000") {
      //                   this.ifedit=false
      //                   this.reload()
      //               } else {
      //                 this.$message({
      //                   message: this.upload,
      //                   type: "warning"
      //                 });
      //               }
      //             })
      //             .catch(error => {
      //               console.log(error);
      //             })
      //           }else{
      //             if(this.em == undefined){
      //               this.flag3=true;
      //               this.flag4=false;
      //             }else{
      //               if(this.em.length==0){
      //                 this.flag3=true;
      //                 this.flag4=false;
      //               }else{
      //                 if(reg.test(this.em)){
      //                   this.flag3=false;
      //                   this.flag4=false;
      //                 }else{
      //                   this.flag3=false;
      //                   this.flag4=true;
      //                 }
      //               }
      //             }
      //           }
      //       }else{
      //         this.flag5=true;
      //       }    
      // }else{
      //   this.flag5=false;
      //   if(reg.test(this.em)){
      //     this.flag3=false;
      //     this.flag4=false;
      //     this.flag5=false;
      //     if (this.picImg == "") {
      //       var params = Qs.stringify({
      //         nickname: this.nc,
      //         sex: this.value,
      //         mobile: this.phone,
      //         email: this.em,
      //         address: this.adr
      //       });
      //     }else {
      //       var params = Qs.stringify({
      //         nickname: this.nc,
      //         sex: this.value,
      //         mobile: this.phone,
      //         email: this.em,
      //         photoUrl: this.picImg,
      //         address: this.adr
      //       });
      //     }
      //     updateBasicInfo(params)//修改用户基本信息
      //       .then(res => {
      //         console.log('提交返回：',res);
      //         if (res.data.header.status == "1000") {
      //             this.ifedit=false
      //             this.reload()
      //         } else {
      //           this.$message({
      //             message: this.upload,
      //             type: "warning"
      //           });
      //         }
      //       })
      //       .catch(error => {
      //         console.log(error);
      //       })
      //   }else{
      //     if(this.em == undefined){
      //       this.flag3=true;
      //       this.flag4=false;
      //     }else{
      //       if(this.em.length==0){
      //         this.flag3=true;
      //         this.flag4=false;
      //       }else{
      //         if(reg.test(this.em)){
      //           this.flag3=false;
      //           this.flag4=false;
      //         }else{
      //           this.flag3=false;
      //           this.flag4=true;
      //         }
      //       }
      //     }
      //   }
      // }
    }

  }
};
</script>

<style>
.mynews .el-button--primary{
background-color: rgb(9,81,150);
border-color: rgb(9,81,150);
}
.sel {
  width: 75%;
  box-sizing: border-box;
  text-align: right;
}
.sel .el-input {
  height: 2.5rem;
  line-height: 2.5rem;
  text-align: right;
}
.sel .el-input__inner {
  border-radius: 0;
  border: 0;
  font-size: 0.8rem;
  height: 2.5rem;
  line-height: 2.5rem;
  color: #3f3f3f;
  text-align: right;
  background: transparent;
}
</style>
<style scoped>
/*头部*/
.title{
  font-size: .80rem;
  display: block;
  color: #828282;
  text-align:center;
  padding-top:5px;
}
.logo {
  text-align: center;
  width: 50%;
  margin: 0 auto;
  margin-top: 8px;
}

.logo img {
  width: 100%;
}

.pro_pic {
  width: 100%;
  text-align: center;
  margin: 0.5rem 0;
}
.pro_pic img {
  width: 5.625rem;
  height: 5.625rem;
  border-radius: 50%;
}
/*信息*/
.news {
  width: 90%;
  margin: 0 auto;
}
.news .pos {
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  border-bottom: 1px solid #dadada;
}
.pos input {
  width: 75%;
  border: 0px;
  box-sizing: border-box;
  padding-left: 10px;
  height: 2.6rem;
  line-height: 2.6rem;
  font-size: 0.8rem;
  background: transparent;
  text-align: right;
}
.pos input:disabled {
  border-radius: 0;
  border: 0px;
  opacity: 1;
  color: #3f3f3f;
}
.pos input:focus,
.pos select:focus {
  outline: none;
}
.news span {
  width: 20%;
  height: 2.6rem;
  line-height: 2.6rem;
  box-sizing: border-box;
  font-size: 1rem;
  position:relative;
  white-space: nowrap;
  text-align: left;
  color: #333333;
}
.news span img{
  width: 1.2rem;
  margin-right: 0.5rem;
  vertical-align: middle;
}
.denger{
  font-size: .625rem;
  margin-top: 5px;
  color: red;
}
.news .el-button {
  width: 72%;
  margin-left: 14%;
  font-size: 1rem;
  height: 2.6rem;
  line-height: 2.6rem;
  color: rgb(255,255,255);
  margin-top: 30px;
  border-radius: 1.3rem;
  background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
  border: 0;
  padding: 0 0;
}
.hiddenInput {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/m_page/login/mynews.vue